import type { CSSProperties } from 'react';

/** Editor placement width for a full-width block in the composition row. */
export const PLACEMENT_WIDTH_FULL = 400;

/** Editor placement width for a half-width block in the composition row. */
export const PLACEMENT_WIDTH_HALF = 200;

const GUTTER_PX = 16;

/**
 * Flex-item style for one template block in the flow-based preview.
 * Matches the POC `blockLayoutStyle` semantics (percentage widths, not px).
 *
 * Editor persists 400 = full and 200 = half. Legacy pdf-templates / pdfme
 * positional widths (0, 10, 100, …) render as full width in the flow preview.
 */
export function blockPlacementLayoutStyle(placementWidth: number | undefined): CSSProperties {
  if (placementWidth == null || !Number.isFinite(placementWidth) || placementWidth <= 0) {
    return { flexBasis: '100%', maxWidth: '100%', boxSizing: 'border-box' };
  }

  if (placementWidth >= PLACEMENT_WIDTH_FULL - 50 || placementWidth > 250) {
    return { flexBasis: '100%', maxWidth: '100%', boxSizing: 'border-box' };
  }

  if (placementWidth >= PLACEMENT_WIDTH_HALF - 50 && placementWidth <= PLACEMENT_WIDTH_HALF + 50) {
    return {
      flexBasis: '50%',
      maxWidth: '50%',
      boxSizing: 'border-box',
      paddingRight: GUTTER_PX
    };
  }

  return { flexBasis: '100%', maxWidth: '100%', boxSizing: 'border-box' };
}
